import React from 'react';

import ResponsiveConditional from '@/common/components/responsive/ResponsiveConditional.component';
import { IHotelModelInstance } from '@/hotel';
import DesktopHotelPerks from '@/hox-core/components/DesktopHotelPerks.component';
import { AnimatedStack } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';

import { SearchResultsCancellationPolicySidebarSectionContainer } from '.';
import { DisloyaltySidePanel } from '../../booking-membership/components/DisloyaltySidePanel';

export const SearchResultsSidebarContainer: React.FC<{
  hotelModel: IHotelModelInstance;
  showDisloyaltySidePanel: boolean;
}> = ({ hotelModel, showDisloyaltySidePanel }) => {
  const {
    componentProperties: { search },
  } = useTheme();

  return (
    <ResponsiveConditional
      desktop={
        <AnimatedStack s={search?.results?.sidebarContainer?.rowGap}>
          {!showDisloyaltySidePanel && (
            <SearchResultsCancellationPolicySidebarSectionContainer
              hotelReferenceId={hotelModel.referenceId}
            />
          )}
          {/* To show THN price comparison - Price comparison is bound to the CSS-Selector #maincontent + aside section on Desktop, which is being hidden when the disloyalty side panel is shown */}
          {showDisloyaltySidePanel && <section></section>}

          <DesktopHotelPerks
            perks={hotelModel.content.perks}
            css={search?.results?.sidebarContainer?.hotelPerks}
            hotelReferenceId={hotelModel.referenceId}
            showDisloyaltySidePanel={showDisloyaltySidePanel}
          />

          {showDisloyaltySidePanel && <DisloyaltySidePanel />}
        </AnimatedStack>
      }
    />
  );
};
